<template>
    <div id="companyInfo">
        <div class="mybreadcrumb">
            <i class="iconfont icon-qiye-tianchong" style="margin-right:10px;color:#999"></i>
            <el-breadcrumb separator-class="el-icon-arrow-right" >
                <el-breadcrumb-item>企业管理</el-breadcrumb-item>
                <el-breadcrumb-item>企业信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class="info-tittle">基本信息</div>

        <div class="confirm-status">
            <div class="status-wraper">
                <div class="verifystatus commonfz14-co33">认证状态 :</div>
                <div v-show="verifystatus" class="ststus-common">
                    <div v-if="verifystatus=='2'" class="ststus-common notpass">未通过</div>
                    <div v-else-if="verifystatus=='0'" class="ststus-common notverify">未认证</div>
                    <div v-else-if="verifystatus=='1'" class="ststus-common needverify">待审核</div>
                    <div v-else-if="verifystatus=='4'" class="ststus-common hasverify">已认证</div>
                </div>
            </div>
            <span class="seerecord" @click="seeRecord">查看认证记录</span>
        </div>
        <el-form 
        ref="ruleForm" 
        :model="form"
        :rules="rules"
        label-width="145px"
        style="text-align:left;margin-top:20px;padding-left:60px">
            <el-form-item label="企业名称 :" prop="companyname" style="margin-bottom:12px">
                <div style="display:flex;width:100%">
                    <el-autocomplete
                        v-model.trim="form.companyname"
                        style="width:400px"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入企业名称"
                        :trigger-on-focus="false"
                        @select="handleSelect"
                        @input="checkReName"
                        @blur="TYCNameRequest"
                        :maxlength="100"
                    ></el-autocomplete>
                    <div style="display:flex;align-items:center;" v-if="IsNotExistTip">
                            <i class="el-icon-warning" style="color:#F19803;margin-left:8px"></i>
                            <span class="auditTip" style="margin-left:3px">建议检查企业名称是否真实存在</span>
                    </div>
                    <div style="display:flex;align-items:center;" v-else-if="IsNotMatchTip">
                            <i class="el-icon-warning" style="color:#F19803;margin-left:8px"></i>
                            <span class="auditTip" style="margin-left:3px">建议检查企业名称和统一社会信用代码的匹配程度</span>
                    </div>
                    
                </div>
            </el-form-item>

            <el-form-item label="企业账号 :" >
                <span class="companyAccount">{{companyAccount}}</span>
            </el-form-item>
            <el-form-item label="统一社会信用代码 :" prop="societyCode" style="width:100%">
                <div style="display:flex;width:100%">
                    <el-input  v-model="form.societyCode" style="width:400px;display:inline-block" @blur="TYCCodeRequest"></el-input>
                    <div style="display:flex;align-items:center;" v-if="IscreditCodeTip">
                        <i class="el-icon-warning" style="color:#F19803;margin-left:8px"></i>
                        <span class="auditTip" style="margin-left:3px">建议检查统一社会信用代码是否真实存在</span>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="LOGO :" style="padding-top:5px">
                <div class="logo-wraper">
                    <el-avatar shape="circle" :size="80" :src="seeLogo?seeLogo:deflogo"></el-avatar>
                    <div class="logo-btn" @click="logoDialog=true">更换LOGO</div>
                </div>
            </el-form-item>

            <el-form-item label="营业执照 :" :prop="verifystatus=='0'?'imageUrl':'seeUrl'" class="uploadclass"  style="padding-top:5px">
                <!--显示从文件夹上传的图片-->
                <img  v-if="imageUrl"  :src="imageUrl" alt="图片加载失败" class="avatar">
                <!--显示默认图片或回显图片-->
                <div v-else>
                    <div v-if="isdefaultshow" style="background: #F7F7F7;border: 1px solid #E0E0E0;width:160px;height:160px;display:flex;justify-content:center;align-items:center">
                        <img :src="seeUrl" alt="图片加载失败">
                    </div>
                    <img v-else :src="seeUrl" alt="图片加载失败" class="avatar">
                </div>
                <div style="margin-left:22px">
                    <div style="color:#666666;width:218px;font-size:12px;line-height:21px;text-align:left">
                        上传：营业执照图片；
                        照片所有信息需清晰可见，内容真实有效，不得做任何修改。
                        照片支持jpg、jpeg、bmp、gif、png格式，大小不超过5M。
                    </div>
                    <el-upload
                        class="avatar-uploader"
                        ref="myupload"
                        :action="action"
                        :show-file-list="false"
                        :file-list="filelist"
                        :auto-upload="false"
                        :on-success="handleAvatarSuccess"
                        :on-change="handleChange"
                        :headers="headers"
                        :http-request="httprequest">
                        <div class="upbtn">选择文件</div>
                    </el-upload>
                </div>
            </el-form-item>
            <div class="info-tittle" style="position:relative;left:-60px;margin-top:30px">
                联系方式
            </div>
            <el-form-item label="联系人 :" prop="contacts" style="margin-top:20px">
                <el-input  v-model.trim="form.contacts" class="inputwidth"></el-input>
            </el-form-item>
            <el-form-item label="联系人手机号 :" prop="contactsPhone">
                <el-input  v-model="form.contactsPhone" class="inputwidth"></el-input>
            </el-form-item>
            <div>
                <div class="slect-top">
                        <el-form-item label="联系地址 :" prop="selectedOptions">
                            <el-cascader
                                style="width:400px"
                                size="large"
                                :options="caseroptions"
                                v-model="form.selectedOptions"
                                @change="caserhandleChange">
                            </el-cascader>
                        </el-form-item>
                    </div>
                    <div class="detailaddress">
                        <el-form-item label="详细地址 :" prop="detailedAddress">
                            <el-input  v-model.trim="form.detailedAddress" class="inputwidth" placeholder="请输入详细地址" ></el-input>
                        </el-form-item >
                    </div>
            </div>
            
            <el-form-item label="备注 :">
                <el-input type="textarea" v-model="form.desc" class="inputwidth formarea"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary"
                size="medium" 
                style="float:left" 
                @click="submitForm('ruleForm')" 
                :disabled="buttonDisable">{{buttonTittle}}</el-button>
                <el-button
                @click="cancleAudit"
                size="medium" style="float:left;margin-left:15px">取消认证</el-button>
            </el-form-item>
        </el-form>

        <el-dialog
            title="历史认证记录"
            :visible.sync="dialogVisible"
            width="1160px">
            <el-table
                :data="tableData"
                border
                :header-cell-style="{color:'#333333',fontFamily:'MicrosoftYaHei',fontSize:'12px',fontWeight:400,padding:'9px 0',background:'#F5F5F5'}"
                :cell-class-name="tabCellClassName"
                style="width: 100%">
                <el-table-column
                    label="序号"
                    type="index"
                    width="50"
                    align="center"
                    >
                <template slot-scope="scope">
                    <span>{{scope.$index + 1}}</span>
                </template>
                </el-table-column>
                <el-table-column
                    prop="enterpriseName"
                    label="企业名称"
                    align="center"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="enterpriseAccount"
                    label="企业账号"
                    align="center"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="enterpriseCode"
                    label="统一社会信用代码"
                    align="center"
                    width="120"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="contactPerson"
                    label="联系人"
                    align="center"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    width="100"
                    label="联系人手机号"
                    align="center"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="contactAddress"
                    label="联系地址"
                    align="center"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="createdAt"
                    label="申请时间"
                    align="center"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="auditedAt"
                    label="审核时间"
                    align="center"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="certificatationType"
                    label="认证分类"
                    width="80"
                    align="center">
                </el-table-column>
                <el-table-column
                    label="认证状态"
                    align="center"
                    width="130">
                    <template slot-scope="scope">
                        <div v-if="scope.row.certificatationStatus=='1'" class="common-status" style="background: #EEBA50;">待审核</div>
                        <div v-else-if="scope.row.certificatationStatus=='2'" class="common-status" style="background: #E96969;">未通过</div>
                        <div v-else-if="scope.row.certificatationStatus=='4'" class="common-status" style="background: #58C99A;">已认证</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="reason"
                    label="审核不通过原因"
                    show-overflow-tooltip
                    align="center"
                    width="130">
                </el-table-column>
            </el-table>
        </el-dialog>
        
        <el-dialog
            title="更换LOGO"
            :visible.sync="logoDialog"
            width="600px"
            :close-on-click-modal="false">
            <AvatorCut 
            @logoCutSuccess="logoCutSuccess" 
            @closeAvatorDialog="logoDialog=false"></AvatorCut>
        </el-dialog>

    </div>
</template>

<script>
import {searchCompanyListApi} from '@/js/api' 
import {AuditHistoryList,enterPriseDetailInfo,Canuse} from '@/js/enterPriseApi'
import deflogo from '@/assets/img/companyuserpng/deflogo.png'
import {BASE_URL} from "../../../../config/env";
import { regionData,CodeToText,TextToCode} from 'element-china-area-data'
import Bus from '@/js/bus'
import {TYCSocietyCodeApi} from '@/js/api.js'
import Moment from 'moment'
import axios from 'axios';
import AvatorCut from '@/view/commonRepeat/AvatorCut.vue'
export default {
    name:'companyInfo',
    components:{
        AvatorCut
    },
    data(){
        var checkPhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'));
        } else {
          const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号'));
          }
        }
      };
      var checkcode=(rule, value, callback) => {
        if (!value) {
          return callback(new Error('统一社会信用代码不能为空'));
        } else {
          const reg = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的18位统一社会信用代码'));
          }
        }
      };
      var checkimgurl=(rule, value, callback) => {
        if (!this.imageUrl) {
            this.$message.error('请上传营业执照')
            return callback(new Error('请上传营业执照'));
        }
        callback();
      };
      var checkseeurl=(rule, value, callback) => {
        if (!this.seeUrl) {
            this.$message.error('请上传营业执照')
            return callback(new Error('请上传营业执照'));
        }
        callback();
      };
        return{
            caseroptions: regionData,
            isdefaultshow:true,//默认展示默认的图片
            dialogVisible:false,
            IsnameCanUse:false,//判断该企业名是否可用
            verifystatus:'0',
            imageUrl:null,
            seeUrl:require('@/assets/img/wxzfbpay/updefault.png'),
            action:BASE_URL.TEST_HOST_API+'/api/Enterprise/SubmitAudit',
            noimageaction:BASE_URL.TEST_HOST_API+'/api/Enterprise/ReSubmitAudit',
            headers:{
                Authorization:window.localStorage.getItem('token')
            },
            deflogo,
            seeLogo:null,
            logoBlob:null,
            logoDialog:false,
            form: {
                selectedOptions: [],
                companyname: '',//企业名
                societyCode:'',//社会信用代码
                contacts:'',//联系人
                contactsPhone:'',//联系人手机号
                desc:'',
                type: [],
                detailedAddress: ''//详细地址
            },
            rules: {
                companyname: [
                    { required: true, message: '请输入企业名称', trigger: 'blur' },
                    ],
                selectedOptions: [{ required: true, message: '请选择地址', trigger: 'change' },],
                detailedAddress:[{ required: true, message: '请输入详细地址', trigger: 'blur' },],
                societyCode:[
                    {required: true,validator: checkcode, trigger: 'blur'},
                    ],
                contacts:[
                    //{required: true, message: '请输入联系人', trigger: 'blur'},],
                    {required: true,  message: '请输入联系人', trigger: 'blur' }
                ],
                contactsPhone:[
                    {required:true,validator: checkPhone, trigger: 'blur'}
                ],
                imageUrl:[
                    {required:true,validator: checkimgurl, trigger: 'change'}
                ],
                seeUrl:[
                    {required:true,validator: checkseeurl,trigger: 'change'}
                ],
                },
            tableData:[],//历史认证记录数据
            filelist:[],
            companyAccount:'',
            IscreditCodeTip:false,
            IsNotExistTip:false,//企业名称不存在的提示
            IsNotMatchTip:false,
        }
    },
    computed:{
        buttonTittle(){
            if(this.verifystatus==='0'){
                return '提交认证'
            }else{
                return '重新认证'
            }
        },
        buttonDisable(){
            if(this.verifystatus==='1'){
                return true
            }else{
                return false
            }
        },
        
    },
    created(){
        this.getenterPriseDetailInfo();
    },
    methods:{
        send(){
           this.$store.commit("setCurrentVerifystatus",4)
        },
        cancleAudit(){
            this.$router.push('/companyInfoDetail')
        },
        caserhandleChange(value){
            console.log(value)
        },
        getinfo(){//获取企业信息
            this.imageUrl=null;
            this.getenterPriseDetailInfo();
        },
        logoCutSuccess(blob){//裁剪后的图片文件对象
            
            this.seeLogo=URL.createObjectURL(blob);
            this.logoBlob=blob
            this.logoDialog=false
        },
        TYCNameRequest(){
            setTimeout(()=>{
                if(this.form.companyname){
                    TYCSocietyCodeApi({
                        word:this.form.companyname
                    })
                    .then(res=>{
                        const result=res.data.result
                        if(res.data.error_code===0){
                            if(result && result.name==this.form.companyname){
                                this.IsNotExistTip=false
                                this.checkNameAndCode(result)
                            }else{
                                this.IsNotExistTip=true
                            }
                        }else{
                            if(res.data.error_code===300000){//天眼查无数据情况
                                this.IsNotExistTip=true
                            }else{

                                this.$message.error(res.data.reason)
                            }
                        }

                    })
                    .catch(err=>{
                        this.$message.error('天眼查服务调用失败')
                    })
                }
            },200)
        },
        TYCCodeRequest(){
            if(/^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g.test(this.form.societyCode)){
                TYCSocietyCodeApi({
                    word:this.form.societyCode,
                    token:'bdc33c14-0101-499c-89e4-d50f041b66de'
                })
                .then(res=>{
                    console.log(res)
                    const result=res.data.result
                    if(res.data.error_code===0){
                        
                        if(result && result.creditCode){
                            if(this.form.societyCode==result.creditCode){
                                this.IscreditCodeTip=false//不需要提示社会信用代码不存在
                                this.checkNameAndCode(result)
                            }else{
                                this.IscreditCodeTip=true//需要提示是否存在该信用代码
                            }
                        }
                    }else{
                        if(res.data.error_code===300000){//天眼查无数据情况
                            this.IscreditCodeTip=true//需要提示社会信用代码不存在
                        }else{
                            this.IscreditCodeTip=false//天眼查接口其他报错
                            this.$message.error(res.data.reason)
                        }
                    }
                })
                .catch(err=>{
                    this.$message.error('天眼查服务调用失败')
                })
            }else{
                this.IscreditCodeTip=false
            } 
        },
        checkNameAndCode(result){//在社会信用代码和企业名称都存在的情况下，验证是否和天眼查上相匹配
            if(!this.form.companyname){
                return 
            }
            if(/^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g.test(this.form.societyCode)){
                if(result.name===this.form.companyname && result.creditCode==this.form.societyCode){
                    console.log('匹配')
                    this.IsNotMatchTip=false
                }else{
                    this.IsNotMatchTip=true
                }
            }
        },
        resetForm(){//重置表单
            let that=this;
            that.form.companyname='';
            that.form.contacts='';
            that.form.contactsPhone='';
            that.form.societyCode='';
            that.form.desc='';
            that.form.detailedAddress='';
            that.verifystatus='';
            that.seeUrl=null;
            that.imageUrl=null;
            that.form.detailedAddress='';
            that.form.selectedOptions=[];
        },
        handleSelect(item) {
            console.log(item);
        },
        createStateFilter(queryString) {
            return (state) => {
                
            return (state.value.indexOf(queryString) !=-1);
            };
        },
        querySearchAsync(queryString, cb) {
            if(!queryString)
            return 
            let that = this
            let params = {
                word :queryString,
                //token:'bdc33c14-0101-499c-89e4-d50f041b66de'
            }
            searchCompanyListApi(params)
            .then(res => {
                console.log(res)
                if (res.data.reason == 'ok') {
                    let list=[];
                    for(let v of res.data.result.items){
                        list.push({value:v.name})
                    }
                    let results = list.filter(that.createStateFilter(queryString));
                    //console.log(results);
                    cb(results);
                }else{
                        console.log('无数据')
                        cb([]);
                    }
                })
            .catch(err => {
                console.log(err)
            })
        },
        checkReName(){
            let that=this;
            if(!that.form.companyname)
            return
            Canuse({
                enterpriseName:that.form.companyname,
                enterPriseId:window.localStorage.getItem('enterPriseId')
            })
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data){

                        console.log('企业名称可用')
                    }
                }else{
                    this.$message.error('已存在该企业名称，请联系客服 400-8000-900 ')
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data)
                }
            })
        },
        httprequest(options){//自定义请求
            let that=this;
            const _file = options.file;
            console.log(_file)
            let filterSpace=that.form.companyname.replace(/\s+/g,"");
            // 通过 FormData 对象上传文件
            var formData = new FormData();
            formData.append("BusinessLicenseImage", _file);

            if(this.logoBlob){//如果用户上传了LOGO
                const logofile=new window.File([this.logoBlob],'LOGO图片');
                console.log(logofile)
                formData.append("LogoImage",logofile);
            }

            console.log(formData);
            formData.append("EnterpriseId", window.localStorage.getItem('enterPriseId'));
            formData.append("EnterpriseName",filterSpace);
            formData.append("EnterpriseAccount",this.companyAccount);
            formData.append("EnterpriseCode", that.form.societyCode);       
            formData.append("ContactPerson", that.form.contacts);            
            formData.append("ContactPhone", that.form.contactsPhone);            
            formData.append("Address.Province",CodeToText[that.form.selectedOptions[0]]);            
            formData.append("Address.City", CodeToText[that.form.selectedOptions[1]]);            
            formData.append("Address.AreaOrCounty",CodeToText[that.form.selectedOptions[2]]);            
            formData.append("Address.DetailedAddress",that.form.detailedAddress);            
            formData.append("Remark",that.form.desc);            
            
            console.log(CodeToText[that.form.selectedOptions[0]],CodeToText[that.form.selectedOptions[1]],CodeToText[that.form.selectedOptions[2]])

            if(that.verifystatus=='0'){
                that.postAction(formData,filterSpace)
            }else{
                that.patchAction(formData,filterSpace)
            }
        },
        postAction(formData,filterSpace){
            let that=this;
            axios.post(that.action,formData)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data===true){
                        this.$message.success("提交成功");
                        Bus.$emit('updateCompanyName',filterSpace)
                       
                        // this.$router.push('/companyInfoDetail')
                        this.$router.push({//先跳转该路由判断身份
                            path:'/companyRouteCallback',
                        })
                    }
                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data)
                }
            })
        },
        patchAction(formData,filterSpace){
            
            let that=this;
            axios.patch(that.noimageaction,formData)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data===true){
                        debugger
                        this.$message.success("提交成功");
                        Bus.$emit('updateCompanyName',filterSpace)
                        
                        Bus.$emit('updateSideBar')
                        //this.$router.push('/companyInfoDetail')
                        this.$router.push({//先跳转该路由判断身份
                            path:'/companyRouteCallback',
                        })
                    }
                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data)
                }
            })
        },
        noimageAudit(){//重新认证无图片上传
            let that=this;
            debugger
            // 通过 FormData 对象上传文件
            var formData = new FormData();
            let filterSpace=that.form.companyname.replace(/\s+/g,"");
            if(this.logoBlob){//如果用户上传了LOGO
                const logofile=new window.File([this.logoBlob],'LOGO图片');
                console.log(logofile)
                formData.append("LogoImage",logofile);
            }
            formData.append("EnterpriseId", window.localStorage.getItem('enterPriseId'));
            formData.append("EnterpriseName",filterSpace);
            formData.append("EnterpriseAccount",this.companyAccount);
            formData.append("EnterpriseCode", that.form.societyCode);       
            formData.append("ContactPerson", that.form.contacts);            
            formData.append("ContactPhone", that.form.contactsPhone);            
            formData.append("Address.Province",CodeToText[that.form.selectedOptions[0]]);            
            formData.append("Address.City", CodeToText[that.form.selectedOptions[1]]);            
            formData.append("Address.AreaOrCounty",CodeToText[that.form.selectedOptions[2]]);            
            formData.append("Address.DetailedAddress",that.form.detailedAddress);            
            formData.append("Remark",that.form.desc);
            
            console.log(CodeToText[that.form.selectedOptions[0]],CodeToText[that.form.selectedOptions[1]],CodeToText[that.form.selectedOptions[2]])
            
            axios.patch(that.noimageaction,formData)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    
                    if(data===true){
                        this.$message.success("提交成功");
                        Bus.$emit('updateCompanyName',filterSpace)
                        // this.$router.push('/companyInfoDetail')
                        this.$router.push({//先跳转该路由判断身份
                            path:'/companyRouteCallback',
                        })
                        
                    }
                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data)
                }
            })
        },
        getenterPriseDetailInfo(){//先获取企业详细信息
            let that=this;
            let params={
                enterPriseId:window.localStorage.getItem('enterPriseId')
            };
            enterPriseDetailInfo(params)
            .then(res=>{
                console.log(res);
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data===null){//现在不管是不是未认证、都是可能走下面的流程
                        this.verifystatus='0';
                        this.companyAccount=window.localStorage.getItem('userAccount')
                    }else{
                        that.form.companyname=data.enterpriseName;
                        that.form.contacts=data.contactPerson;
                        that.form.contactsPhone=data.contactPhone;
                        that.form.societyCode=data.enterpriseCode;
                        that.seeLogo=data.logoImageInAliyunOSSViewPath
                        this.companyAccount=data.enterpriseAccount;
                        if(!data.remark){
                            that.form.desc='';
                        }else{
                            that.form.desc=data.remark;
                        }
                        
                        that.verifystatus=data.certificatationStatus.toString();
                        that.$store.commit("setCurrentVerifystatus",data.certificatationStatus);

                        if(data.address){
                            let myprovince=TextToCode[data.address.province].code;
                            let mycity=TextToCode[data.address.province][data.address.city].code;
                            let myarea=TextToCode[data.address.province][data.address.city][data.address.areaOrCounty].code;
                            that.form.selectedOptions=[myprovince,mycity,myarea]; 
                            if(!data.address.detailedAddress){
                                data.address.detailedAddress='';
                            }else{
                                that.form.detailedAddress=data.address.detailedAddress;
                            }                      
                        }
                        if(data.businessLicenseImageInAliyunOSSViewPath){
                            that.$nextTick(()=>{
                                that.isdefaultshow=false
                                that.seeUrl=data.businessLicenseImageInAliyunOSSViewPath;
                            })
                        }                
                    }
                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data)
                }
            })
        },
        handleAvatarSuccess(res, file,filelist) {
            console.log('handleSuccess',res);
            this.filelist.forEach(item=>{
                item.status='ready';
            })
        },
        handleChange(file,filelist){//选择文件，上传前，上传成功，上传失败
            
            console.log(file);
            console.log(filelist);
            let { type,size } = file.raw;
            console.log(type,size)
            if (!/(png|gif|jpeg|jpg|bmp)/i.test(type)) {
                this.$message.error("图片格式不正确~~");
                this.imageUrl=null;
                this.filelist=[];
                return false;
            }
            if (size > 5 * 1024 * 1024) {
                this.$message.error("图片过大，请上传小于5MB的文件~~");
                this.imageUrl=null;
                this.filelist=[];
                return false;
            }
            if (size < 5  * 1024) {
                this.$message.error("图片过小，请上传大于5KB的文件~~");
                this.imageUrl=null;
                this.filelist=[];
                return false;
            }
            if(filelist.length>0){
                this.filelist=[filelist[filelist.length - 1]]
            }
            this.imageUrl = URL.createObjectURL(file.raw);
            this.$refs.ruleForm.clearValidate('imageUrl')

        },
        submitForm(formName) {//提交认证按钮点击
            let that=this;
            console.log('提交认证')
            console.log(formName);
            console.log(this.$refs[formName]);
            this.$refs[formName].validate((valid) => {
                console.log(valid)
                if (valid) {
                   
                    Canuse({
                        enterpriseName:that.form.companyname,
                        enterPriseId:window.localStorage.getItem('enterPriseId')
                        })
                    .then(res=>{
                        if(res.status===200 && res.data.error_code===0){
                            const {data}=res.data;
                                if(data){
                                    if(that.imageUrl){//包函营业执照的提交
                                        that.$refs.myupload.submit();
                                    }else{//不包含营业执照的提交
                                        that.noimageAudit();
                                    }
                                }
                            }else{
                                this.$message.error('已存在该企业名称，请联系客服 400-8000-900 ')
                            }
                        })
                    .catch(err=>{
                        console.log(err)
                        if(err.data && err.data.errorMessages){
                            that.$message.error(err.data.errorMessages[0]);
                        }else if(err.data){
                            that.$message.error(err.data)
                         }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        seeRecord(){//查看历史认证记录
            let that=this;
            that.tableData=[];
            that.dialogVisible=true;
            AuditHistoryList({
                enterPriseId:window.localStorage.getItem('enterPriseId')
            })
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    data.forEach((item,index)=>{
                        let obj={
                            enterpriseName:item.enterpriseName,
                            enterpriseAccount:item.enterpriseAccount,
                            enterpriseCode:item.enterpriseCode,
                            contactPhone:item.contactPhone,
                            certificatationStatus:item.certificatationStatus,
                            certificatationType:item.certificatationType,
                            createdAt:item.createdAt?Moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss'):'',
                            auditedAt:item.auditedAt?Moment(item.auditedAt).format('YYYY-MM-DD HH:mm:ss'):'',
                            reason:item.auditType?item.auditDetail?item.auditType+' '+item.auditDetail:item.auditType:'',
                            auditType:item.auditType,
                            auditDetail:item.auditDetail,
                            contactPerson:item.contactPerson
                        }
                        if(item.address){
                            if(item.address.detailedAddress){
                                obj.contactAddress=item.address.province+item.address.city+item.address.areaOrCounty+' '+item.address.detailedAddress
                            }else{
                                obj.contactAddress=item.address.province+item.address.city+item.address.areaOrCounty
                            }
                        }else{
                            obj.contactAddress=''
                        }
                        that.tableData.push(obj);
                    })
                }else{
                    that.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err);
                if(err.data.status==404){
                    that.$message.error('暂无认证记录！');
                    return 
                }
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data)
                }
            })
        },
        tabCellClassName({row, column, rowIndex, columnIndex}){
            return 'cellstyle'
        },
        
    }
}
</script>
<style lang="scss">
#companyInfo{
     .avatar-uploader{
        margin-top: 20px;
        overflow: hidden;
      .el-upload{
          float: left;
      }
  }
    .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 160px;
    height: 160px;
    line-height: 160px;
    text-align: center;
  }
  .avatar-uploader .upbtn{
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #0069e0;
    background: #F0F6FD;
    border: 1px solid rgba(0,105,224,0.45);
    border-radius: 2px;
    width: 110px;
    height: 36px;
    line-height: 36px;
    
  }
  .avatar {
    width: 160px;
    height: 160px;
    margin-left: 0px;
    border-radius:2px;
  }
  .uploadclass{
      width: 800px;
      .el-form-item__content{
          display: flex;
      }
  }
  
}
  
</style>

<style lang="scss" scoped>
    #companyInfo{
        background-color: #fff;
        padding-bottom:60px;
        /deep/ .el-breadcrumb{
            .el-breadcrumb__inner{
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #666666;
                font-weight: 400;
            }
            .el-breadcrumb__separator{
                font-size: 12px !important;
                color: #666666;
            }
        }
        .mybreadcrumb{
            padding: 13px 0 13px 20px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #EAEAEA;
        }
        .info-tittle{
            text-align: left;
            margin-left: 30px;
            padding-left: 10px;
            border-left: 3px solid #0069e0;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #0069e0;
            font-weight: 700;
            margin-top: 20px;
        }
        .confirm-status{
            overflow: hidden;
            position: relative;
            display: flex;
            align-items: center;
            margin:10px 30px 0px 0px;
            padding-left: 60px;
            .status-wraper{
                
                bottom: 0px;
                .verifystatus{
                    display: inline-block;
                    width: 145px;
                    padding-right: 12px;
                    text-align: right;
                }
                .ststus-common{
                    display: inline-block;
                    width: 70px;
                    height: 30px;
                    line-height: 30px;
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #FFFFFF;
                    font-weight: 400;
                    border-radius: 15px;
                }
                .notpass{
                    background: #E96969;
                }
                .notverify{
                    background: #BDC2C6;
                }
                .needverify{
                    background: #EEBA50;
                }
                .hasverify{
                    background: #1DCB96;
                }
            }
            .seerecord{
                margin-left: 15px;
                font-size: 12px;
                color: #0069e0;
                font-family: MicrosoftYaHei;
                cursor: pointer;
            }
        }
        .logo-wraper{
            display: flex;
            
            .logo-btn{
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #0069e0;
                background: #F0F6FD;
                border: 1px solid rgba(0,105,224,0.45);
                border-radius: 2px;
                width: 110px;
                height: 36px;
                line-height: 36px;
                text-align: center;
                cursor: pointer;
                margin-left: 102px;
            }
        }
        .companyAccount{
            float: left;
        }
        .formarea{
            /deep/ .el-textarea__inner{
                height: 108px;
                resize: none;
            }
        }
        .slect-top{
            display: flex;
            width: 545px;
            justify-content: space-between;
            
            .el-select{
                width: 195px;
            }
            .item-two{
                    /deep/ .el-form-item__content{
                    margin-left: 0px !important;
                }
            }
        }
        //公共样式
        .common-status{
            color: #FFFFFF;
            width: 50px;
            height: 18px;
            text-align: center;
            border-radius: 2px;
            line-height: 18px;
            margin: 0 auto;
        }
        .commonfz14-co33{
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #333333;
            font-weight: 400;
        }
        .inputwidth{
            width: 400px;
        }
        .auditTip{
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #E48F00;
        }
        //element-ui样式
        /deep/ .el-table .cellstyle{
            padding: 0px;
            height: 40px;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #666666;
            font-weight: 400;
        }
        /deep/ .el-form-item{
            
            margin-bottom: 20px;
            .el-form-item__label{
                color: #333;
            }
        }
        /deep/ .el-dialog{
            border-radius: 2px;
            width: 1000px;
            .el-dialog__header{
                background: #0069e0;
                text-align: left;
                padding: 15px 20px;
                .el-dialog__title{
                    font-family: MicrosoftYaHei;
                    font-size: 16px;
                    color: #FFFFFF;
                    font-weight: 400;
                }
                .el-dialog__close{
                    color: #fff;
                }
            }
        }

    }
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/companyManage/companyInfo.vue